module.exports = __webpack_public_path__ + "static/img/fin sec.02293ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/fin sec.jpg
// module id = /m+D
// module chunks = 1